import React from 'react'
import { IBadgeProps } from './interfaces'
import { Tooltip } from 'antd'
import { StatusType } from '../../enums/status-type'
import { titleCase } from '../../_utils/utils'
import './status-badge.scss'
import { BuildOutlined, CheckCircleOutlined, FileExclamationOutlined, PauseCircleOutlined } from '@ant-design/icons'

/*
    "expanded" view forces hidden tooltip
    and displays the status text to the right
    of the badge
 */
interface IProps extends IBadgeProps {
    status: string
    expanded?: boolean
}

export const JourneyStatusBadge: React.FC<IProps> = (props) => {
    const hideTooltip = props.hideTooltip || props.expanded

    let text = props.status
    let icon = <CheckCircleOutlined />

    switch (props.status) {
        case StatusType.ACTIVE.name:
            icon = <BuildOutlined />
            text = 'RUNNING'
            break
        case StatusType.DRAFT.name:
            icon = <FileExclamationOutlined />
            break
        case StatusType.PAUSED.name:
            icon = <PauseCircleOutlined />
            break
        default:
            break
    }

    const badge = <span className={`status-icon status-${text}`}>{icon}</span>

    return (
        <span className="status-badge journey-status-badge">
            {hideTooltip ? (
                !props.expanded ? (
                    badge
                ) : (
                    <>
                        {badge}
                        <span className="status-name">{titleCase(text)}</span>
                    </>
                )
            ) : (
                <Tooltip title={props.tooltip || text}>{badge}</Tooltip>
            )}
        </span>
    )
}
